var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.LfBlueTitleComponent, { attrs: { title: _setup.texts.title } }),
      _c(_setup.LfSimpleProgressBarComponent, {
        attrs: { text: _setup.texts.caption, icon: _setup.icon },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }